import { render, staticRenderFns } from "./PatriotPaystubView.vue?vue&type=template&id=039c8d31&scoped=true&"
import script from "./PatriotPaystubView.vue?vue&type=script&lang=ts&"
export * from "./PatriotPaystubView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039c8d31",
  null
  
)

export default component.exports